const stickyHeader = () => {
  const header: HTMLElement = document.querySelector('.header');
  const headerScroll: string = 'header--scroll';
  let positionElement: number = header.clientHeight;
  const consentInput: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.ginput_container_consent input[type="checkbox"]');

  consentInput.forEach((input) => {
    input.setAttribute('tabindex', '0');
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        input.click();
      }
    });
  });

  window.addEventListener('scroll', function onScroll() {
    // Get scroll position
    const scrollHeight: number = this.scrollY;

    // If scroll height reaches position height, add class
    if (scrollHeight >= positionElement) {
      header.classList.add(headerScroll);
    } else {
      header.classList.remove(headerScroll);
    }
  }, { passive: true });

  window.addEventListener('resize', () => {
    positionElement = header.clientHeight;
  }, { passive: true });
};

export default stickyHeader;
